import { defineComponent as _defineComponent } from 'vue'
import BCXUserBanner from '@/components/molecules/BCXUserBanner.vue';
import { Invitee, PAGE_SIZE_INVITEES } from '@/models/Invitation';
import InviteeStatus from '@/views/invites/InviteeStatus.vue';
import { computed, PropType } from 'vue';
import BCXTable from '@/components/BCXTable.vue';
import useI18n from '@/mixins/useI18n';
import useResponsiveness from '@/mixins/useResponsiveness';


export default /*#__PURE__*/_defineComponent({
  __name: 'InviteesTable',
  props: {
  invitees: {
    type: Array as PropType<Invitee[]>,
    default: () => []
  }
},
  setup(__props) {



const { t } = useI18n();
const { isMobileWidth } = useResponsiveness();

const fields = ['user', 'since', 'code', 'notes'];
const headerTitles = computed(() => [
  t('invites.columns.user'),
  t('invites.columns.memberSince'),
  t('invites.columns.code'),
  t('invites.columns.notes'),
]);
const getDisplayValue = (fieldName: string, obj: Invitee) => {
  switch (fieldName) {
    case 'user': return obj.invitedUserId;
    case 'notes': return obj.userNote || '-';
    case 'code': return obj.inviteCode;
  }
  return obj;
};


return { __sfc: true,t, isMobileWidth, fields, headerTitles, getDisplayValue, BCXUserBanner, PAGE_SIZE_INVITEES, InviteeStatus, BCXTable }
}

})